(function fullImageViewerState(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.EventBus ||
    !global.NewHomeSource.FullImageViewer.UrlHandler ||
    !global.NewHomeSource.FullImageViewerSetters ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const previousFullImageViewerState = global.NewHomeSource.FullImageViewerState;
  const eventBus = new global.NewHomeSource.EventBus();
  const fullImageViewerData = { };
  const allImages = [];

  /**
   * @private
   * getThumbnailSrc: returns a default thumbnail if the image collection is rich media, otherwise: this will return
   * the src property of the image.
   *
   * @param {object} data with the information relevat of the element.
   */
  function getThumbnailSrc(data, thumbnailUrl) {
    const url = thumbnailUrl || '';
    const isValidImage = url.match(/(?:jpg|gif|png|svg|webp)/);
    return !isValidImage
      ? global.NewHomeSource.FullImageViewer.Config.defaultThumbs[data.CollectionName]
      : thumbnailUrl;
  }

  /**
   * @private
   * processImage: adds the relevat image information into the fullImageViewerData collection.
   *
   * @param {string} collectionName name of the image collection.
   * @param {object} image with the information relevat of the element.
   * @param {int} index image index.
   */
  function processImage(collectionName, image, index) {
    if (image.Type.toLowerCase() === 'vid' && !image.VideoId) {
      return;
    }

    const dataUrl = global.NewHomeSource.FullImageViewer.UrlHandler
      .removeQueryString(global.NewHomeSource.ThumbnailHelper.validate(image));
    const imageElement = { };

    imageElement.Alt = image.AltText || image.Description || image.CollectionName;
    imageElement.Collection = collectionName;
    imageElement.Description = image.Description || image.AltText || image.CollectionName;
    imageElement.Id = image.Id;
    imageElement.Index = index + 1;
    imageElement.Is360Image = image.Is360Image;
    imageElement.IsCtaSlide = false;
    imageElement.IsSelected = false;
    imageElement.OpenExternally = image.OpenExternally;
    imageElement.Title = image.Title || image.CollectionName;
    imageElement.Source = image.IsRichMedia ? image.Url : dataUrl;
    imageElement.EmbedCode = image.EmbedCode;
    imageElement.IsFrame = image.IsRichMedia;
    imageElement.ThumbnailUrl = getThumbnailSrc(image, dataUrl);
    imageElement.VideoId = image.VideoId;
    imageElement.VideoType = image.VideoType;
    imageElement.Type = image.Type;
    imageElement.IsGalleryResource = true;
    if (image.VideoId) {
      imageElement.VideoUrl = image.Url;
    }

    this['Image' + image.Id] = imageElement;
    allImages.push(imageElement);
  }

  function FullImageViewerState() {
  }

  /**
   * @private
   * processCollection: adds relevant collection information into the fullImageViewerData
   *
   * @param {object} collection with the information relevant for the collection.
   */
  FullImageViewerState.processCollection = function processCollection(collection) {
    const collectionConfig = global
      .NewHomeSource
      .FullImageViewer
      .Config
      .collectionConfig[collection.Name.toLowerCase()] ||
      {};

    fullImageViewerData[collection.Name] = {};
    fullImageViewerData[collection.Name].Images = {};
    fullImageViewerData[collection.Name].IsSelected = false;
    fullImageViewerData[collection.Name].Name = collection.Name;
    fullImageViewerData[collection.Name].TotalImages = collection.Elements.length;

    if (Object.prototype.hasOwnProperty.call(collectionConfig, 'processImage')) {
      const imagesAdded = collectionConfig.processImage.call(collection.Elements, collection.Name);
      allImages.push(imagesAdded);
      fullImageViewerData[collection.Name].Images = [imagesAdded];
    } else {
      collection.Elements.forEach(processImage.bind(fullImageViewerData[collection.Name].Images, collection.Name));
    }
  };

  /**
   * @public
   * add: adds a new Observer to the Event bus for the given topic.
   *
   * @param {string} topic to identify the data needed for the observer.
   * @param {function} observer function to be called when the topic has changed.
   */
  FullImageViewerState.add = function add(topic, observer) {
    eventBus.addObserver(topic, observer);
  };

  /**
   * @public
   * get: gets the Full Image Viewer State.
   */
  FullImageViewerState.get = function get() {
    return Object.assign({ images: allImages }, fullImageViewerData);
  };

  FullImageViewerState.getViewerData = function getViewerData() {
    return Object.assign({}, fullImageViewerData);
  };

  FullImageViewerState.setTotalCollections = function setTotalCollections(totalCollections) {
    fullImageViewerData.TotalCollections = totalCollections;
  };

  FullImageViewerState.getAllImages = function getAllImages() {
    return Object.assign([], allImages);
  };

  FullImageViewerState.pushCtaLastImage = function pushCtaLastImage(lastImage) {
    allImages.push(lastImage);
  };

  FullImageViewerState.eventBus = eventBus;

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewerState to the previous script.
   */
  FullImageViewerState.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewerState = previousFullImageViewerState;
    return FullImageViewerState;
  };

  global.NewHomeSource.FullImageViewerState = FullImageViewerState;
}(window));
